import { Flex, GridItem, GridLayout, Skeleton } from '@nilohealth/core-ui'

import { NavbarContainer } from '@navbar/navbar.styles'

const NavbarSkeleton = () => {
  return (
    <NavbarContainer>
      <GridLayout alignItems="center">
        <GridItem
          css={{
            alignSelf: 'center',
            '@xs': { gridColumn: 'span 6' },
            '@sm': { gridColumn: 'span 6' },
            '@md': { gridColumn: 'span 9' },
            '@lg': { gridColumn: 'span 9' },
            '@xl': { gridColumn: 'span 9' },
          }}
        >
          <Flex align="center" gap="xxxsmall">
            <Flex align="center" gap="nano">
              <Skeleton variant="avatar" css={{ height: '$xsmall', width: '$xsmall' }} />

              <Skeleton variant="text" css={{ height: '$xxsmall', width: '$xxxlarge' }} />
            </Flex>

            <Skeleton variant="text" css={{ height: '$xxsmall', width: '$xxxlarge' }} />
            <Skeleton variant="text" css={{ height: '$xxsmall', width: '$xxxlarge' }} />
            <Skeleton variant="text" css={{ height: '$xxsmall', width: '$xxxlarge' }} />
          </Flex>
        </GridItem>

        <GridItem
          css={{
            justifySelf: 'end',
            alignSelf: 'center',
            '@xs': { gridColumn: '-3 / span 2' },
            '@sm': { gridColumn: '-3 / span 2' },
            '@md': { gridColumn: '-4 / span 3' },
            '@lg': { gridColumn: '-4 / span 3' },
            '@xl': { gridColumn: '-4 / span 3' },
          }}
        >
          <Skeleton variant="avatar" css={{ height: '$xsmall', width: '$xsmall' }} />
        </GridItem>
      </GridLayout>
    </NavbarContainer>
  )
}

export default NavbarSkeleton
